import { useEffect, type ReactNode } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useSocket } from '../../socket/SocketProvider'
import { toast } from '../../store/toastStore'
import type { AppNotification } from '../../api/types'

/** Lauscht auf 'notification:new' und hält React-Query-Caches + Toasts aktuell. */
export function NotificationsProvider({ children }: { children: ReactNode }) {
  const socket = useSocket()
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!socket) return

    const onNew = (notification: AppNotification) => {
      queryClient.invalidateQueries({ queryKey: ['notifications'], exact: false })
      toast.info(notification.title + (notification.body ? `: ${notification.body}` : ''))
    }

    socket.on('notification:new', onNew)
    return () => {
      socket.off('notification:new', onNew)
    }
  }, [socket, queryClient])

  return <>{children}</>
}
